import React, { useEffect, useState, useRef } from 'react';
import { Tooltip } from 'reactstrap';
import { ReactComponent as ErrorIcon } from '../../assets/error_red.svg';
import { ReactComponent as SuccessIcon } from '../../assets/ok_green.svg';

import './styles.scss';

import { toJS } from 'mobx';

const Body = ({ children, page, prepareRow, getTableBodyProps }) => {
  return (
    <div {...getTableBodyProps()}>
      {page.map(row => {
        prepareRow(row);
        return (
          <div className="row-main" {...row.getRowProps()} key={row.id}>
            {row.cells.map((cell, i) => (
              <Cell cell={cell} key={row.id + i} />
            ))}
          </div>
        );
      })}
      {children || null}
    </div>
  );
};
export default Body;

const Cell = ({ cell }) => {
  const [isTooltipVisible, setTooltip] = useState(false);
  const ref = useRef();

  const { props: cellProps } = cell.render('Cell');
  const cellId = `cell-${cell.getCellProps().key.replace('[0]', '')}`;
  const [isCellWiderThanColumn, setCellWiderThanColumn] = useState(ref.current?.scrollWidth > ref.current?.offsetWidth);

  useEffect(() => {
    if (ref.current) {
      setCellWiderThanColumn(ref.current.scrollWidth > ref.current.offsetWidth);
    }
  }, [cellProps]);

  return (
    <div className="table-body-cell" ref={ref} {...cell.getCellProps()} {...(isCellWiderThanColumn && { id: cellId })}>
      {isCellWiderThanColumn && cell.column.id !== 'from' && cell.column.id !== 'event' && (
        <Tooltip
          className="styled-tooltip"
          placement="top"
          isOpen={isTooltipVisible}
          target={cellId}
          toggle={() => setTooltip(!isTooltipVisible)}
        >
          {cell.render('Cell')}
        </Tooltip>
      )}

      {cell.column.id !== 'from' && cell.column.id === 'event' && (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          {cell.row.original.typeCode[0] === 'f' && <ErrorIcon className="styled-error-icon" />}
          {cell.row.original.typeCode[0] === 's' && <SuccessIcon className="styled-success-icon" />}
          {toJS(cell.value)}
        </div>
      )}

      {cell.column.id !== 'from' && cell.column.id !== 'event' && cell.render('Cell')}
      {cell.column.id === 'from' && (
        <div>
          {toJS(cell.value).ip} <br /> {toJS(cell.value).location}
        </div>
      )}
    </div>
  );
};
